export default __webpack_public_path__ + "images/3O.6e40ce9.png";